/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Divider,
  Paragraph,
  BaseButton,
  BaseLink,
  BaseLinkStyles
} from 'aether-marketing';
import SignUpPostmanEmail from '../SignUpPostmanEmailField';
import SVGComponent from '../svg/SVGComponent';

/* eslint-disable import/no-extraneous-dependencies */
const pmUuid = require('@postman/uuid');
/* eslint-enable */

const Section = styled.section`
  background-color: ${(props) => props.theme.colors.white};
  padding-top: ${(props) => props.paddingTop || `60px`};
  padding-bottom: ${(props) => props.paddingBottom || `60px`};

  @media screen and (max-width: 1099px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;
const ParentSubtitleText = styled.p`
  color: ${(props) => props.theme.colors.orange_40};
  text-transform: uppercase;
  font-weight: 600;
`;

const Div = styled.div`
  margin-bottom: 24px;
  a {
    ${BaseLinkStyles.componentStyle.rules}
  }

  a.tertiary {
    color: #ff6c37;
  }
  a.tertiary:hover {
    border-bottom: 1px solid #ff6c37;
  }
`;

const SecondaryButton = styled(BaseButton)`
  align-items: center;
  appearance: none;
  border: 1px solid #a6a6a6;
  border-radius: ${(props) => props.theme.borderRadius.small};
  cursor: pointer;
  display: inline-block;
  font-family: ${(props) => props.theme.fonts.Inter};
  font-size: ${(props) => (props.buttonSize === 'sm' ? '14px' : '16px')};
  font-weight: 600;
  line-height: 1.5;
  padding: 8px 16px;
  user-select: none;
  transition: ${(props) => props.theme.transitions.all};
  text-align: center;
  margin: ${(props) => (props.left ? '0 16px 0 0' : '0')};
  &:hover,
  &:active {
    border: 1px solid #3b3b3b;
    text-decoration: none;
  }

  &:disabled,
  &.isDisabled {
    color: ${(props) => props.theme.colors.grey_2};
    cursor: not-allowed;
    background-image: none !important;
    background: ${(props) => props.theme.colors.grey_2};
    border-color: transparent;
  }
`;
function DisplayButtons({ cta, ctaTwo, ctaThree }) {
  const [isToggle, setIsToggle] = useState(false);

  if (isToggle) {
    return (
      <div className="row">
        <div className="col-12 offset-0 col-md-8 offset-md-2 offset-lg-0 col-lg-9">
          <SignUpPostmanEmail />
        </div>
      </div>
    );
  }
  return (
    <div>
      {cta && (
        <BaseButton
          as="a"
          id={cta.id}
          buttonType={cta.buttonType}
          src={cta.src}
          target={cta.target}
          className={cta.className}
          gaCategory={cta.gaCategory}
          gaLabel={cta.gaLabel}
        >
          <span
            data-cdp={`{"event":"CTA Clicked","type":"button","location":"body","destination":"${cta.src}"}`}
          >
            {cta.text}
          </span>
        </BaseButton>
      )}
      {ctaTwo && (
        <SecondaryButton
          buttonType={ctaTwo.buttonType || 'secondary'}
          className={`mt-3 ${ctaTwo.className}`}
          as="a"
          id={ctaTwo.id}
          target={ctaTwo.target}
          dataTest={ctaTwo.target}
          gaCategory={ctaTwo.gaCategory}
          gaLabel={ctaTwo.gaLabel}
          onClick={(e) => {
            setIsToggle(!isToggle);
            e.preventDefault();
          }}
        >
          {ctaTwo.text}
        </SecondaryButton>
      )}
      {ctaThree && (
        <BaseButton
          as="a"
          id={ctaThree.id}
          buttonType={ctaThree.buttonType}
          src={ctaThree.src}
          target={ctaThree.target}
          className={ctaThree.className}
          gaCategory={ctaThree.gaCategory}
          gaLabel={ctaThree.gaLabel}
        >
          {ctaThree.text}
        </BaseButton>
      )}
    </div>
  );
}
DisplayButtons.propTypes = {
  cta: PropTypes.shape({
    id: PropTypes.string,
    buttonType: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string.isRequired
  }),
  ctaTwo: PropTypes.shape({
    buttonType: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    target: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string.isRequired
  }),
  ctaThree: PropTypes.shape({
    id: PropTypes.string,
    buttonType: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string.isRequired
  })
};

DisplayButtons.defaultProps = {
  cta: null,
  ctaTwo: null,
  ctaThree: null
};

function HeroPaidMedia({
  colLeft,
  colRight,
  paddingTop,
  paddingBottom,
  background,
  backgroundColor,
  link,
  titles,
  parentSubtitle,
  body,
  subtitleClass,
  className,
  bodyClassName,
  bodyHTML,
  cta,
  ctaTwo,
  ctaThree,
  footer,
  media,
  divider,
  stickyAttribute
}) {
  const colLeftClass = colLeft ? `col-lg-${colLeft}` : 'col-lg-6';
  const colRightClass = colRight ? `col-lg-${colRight}` : 'col-lg-6';

  return (
    <>
      <Section
        paddingTop={paddingTop || null}
        paddingBottom={paddingBottom || null}
        style={{
          background,
          backgroundColor
        }}
      >
        <div className="container">
          <div className="row">
            <div
              className={`col-sm-12 ${colLeftClass} text-lg-left text-center align-self-center order-2 order-lg-1 mt-5 mt-sm-0`}
            >
              {link && (
                <div className="mb-4">
                  <BaseLink
                    className="text-white"
                    src={link.src}
                    linkType="reversedArrowLink"
                  >
                    {link.text}
                  </BaseLink>
                </div>
              )}
              {titles && <h1 className={`mb-4 ${className}`}>{titles}</h1>}
              {parentSubtitle && (
                <div className="row">
                  <div className="col-12">
                    <ParentSubtitleText>{parentSubtitle}</ParentSubtitleText>
                  </div>
                </div>
              )}
              {body && (
                <Paragraph
                  className={`${
                    subtitleClass === false ? '' : 'subtitle'
                  } ${className} ${bodyClassName}`}
                >
                  {body}
                </Paragraph>
              )}
              {Array.isArray(bodyHTML) && (
                <Div dangerouslySetInnerHTML={{ __html: bodyHTML.join('') }} />
              )}
              <DisplayButtons cta={cta} ctaTwo={ctaTwo} ctaThree={ctaThree} />
              {footer && (
                <div className="row d-none d-lg-flex flex-row pt-4">
                  <div className="col-12">
                    <div dangerouslySetInnerHTML={{ __html: footer.text }} />
                  </div>
                  <div className="col-12 d-none d-lg-flex flex-row justify-content-center justify-content-lg-start">
                    {footer.links.map((footerLink) => (
                      <a
                        key={pmUuid()}
                        data-test={footerLink.dataTest}
                        className="inline mr-3"
                        href={footerLink.href}
                      >
                        {footerLink.image && (
                          <SVGComponent
                            svgContent={footerLink.image.src}
                            fill={footerLink.image.fill}
                            hoverFillColor={footerLink.image.hoverFillColor}
                          />
                        )}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div
              className={`col-sm-12 ${colRightClass} align-self-center order-1 order-lg-2 text-center col-sm-12 col-lg-5 align-self-center order-1 order-lg-2 text-center mb-2 mb-lg-0 `}
            >
              <img
                className="img-fluid"
                src={media.src}
                alt={media.alt}
                fetchpriority="high"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </Section>
      {(divider !== false && <Divider fullWidth />) || null}
      <span data-sticky={stickyAttribute || null} />
    </>
  );
}

HeroPaidMedia.propTypes = {
  colLeft: PropTypes.number,
  colRight: PropTypes.number,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  background: PropTypes.string,
  backgroundColor: PropTypes.string,
  link: PropTypes.shape({
    src: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  titles: PropTypes.string,
  className: PropTypes.string,
  parentSubtitle: PropTypes.string,
  body: PropTypes.string,
  subtitleClass: PropTypes.bool,
  bodyClassName: PropTypes.string,
  bodyHTML: PropTypes.arrayOf(PropTypes.string),
  cta: PropTypes.shape({
    id: PropTypes.string,
    buttonType: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string
  }),
  ctaTwo: PropTypes.shape({
    buttonType: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    target: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string
  }),
  ctaThree: PropTypes.shape({
    id: PropTypes.string,
    buttonType: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.string,
    gaCategory: PropTypes.string,
    gaLabel: PropTypes.string,
    text: PropTypes.string
  }),
  footer: PropTypes.shape({
    text: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        dataTest: PropTypes.string,
        href: PropTypes.string.isRequired,
        image: PropTypes.shape({
          src: PropTypes.string.isRequired,
          fill: PropTypes.string,
          hoverFillColor: PropTypes.string
        })
      })
    )
  }),
  media: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }),
  divider: PropTypes.bool,
  stickyAttribute: PropTypes.string
};

HeroPaidMedia.defaultProps = {
  colLeft: 6,
  colRight: 6,
  paddingTop: '60px',
  paddingBottom: '60px',
  background: null,
  backgroundColor: null,
  link: null,
  titles: null,
  className: '',
  parentSubtitle: null,
  body: null,
  subtitleClass: true,
  bodyClassName: '',
  bodyHTML: null,
  cta: null,
  ctaTwo: null,
  ctaThree: null,
  footer: null,
  divider: true,
  stickyAttribute: null,
  media: {
    src: '',
    alt: ''
  }
};

export default HeroPaidMedia;
